import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { Observable } from 'rxjs';
import { AccountService } from '../../core/account';
import { ApiErrorFactory } from '../../core/api-errors';
import { getImageSrc } from '../../core/image-utilities';
import { ProductSettingsService } from '../../core/product-settings';
import { SiteService } from '../../core/site';
import { Template } from '../../core/template';
import { BaseComponent } from './base.component';
import { CreateFromTemplateService } from './create-from-template.service';

@Component({
  selector: 'app-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TemplateComponent extends BaseComponent implements OnInit {
  starImage: string;
  loading$: Observable<boolean>;

  @Output() isTemplateSelected = new EventEmitter<boolean>();

  constructor(
    protected alertService: SnackbarService,
    protected apiErrorFactory: ApiErrorFactory,
    protected route: ActivatedRoute,
    protected router: Router,
    protected siteService: SiteService,
    protected accountService: AccountService,
    protected createFromTemplateService: CreateFromTemplateService,
    protected productSettingsService: ProductSettingsService,
  ) {
    super(route, router, siteService, accountService, createFromTemplateService, productSettingsService);
    this.starImage = getImageSrc('/images/star-yellow.svg');
  }

  ngOnInit(): void {
    this.calcColumns(window.innerWidth);
    this.loading$ = this.createFromTemplateService.templateLoading$;
  }

  onResize(event: any): void {
    this.calcColumns(event.target.innerWidth);
  }

  selectTemplate(template: Template): void {
    this.createFromTemplateService.setTemplate(template);
    this.isTemplateSelected.emit(true);
  }
}
